// An offer is made once (BLV specs/OFFER_CARD_SPEC.md). In a company design the builder's "offer" IS the company's
// HQ offer (map_offers): making one here makes the HQ row first, then the builder's link row (bb_deals) that routes
// and the map hang off. A personal design has no company, so its offers stay builder-only.
import { supabase } from './supabase.js';
import { workspace } from './stores/workspace.js';

// Builder-style fields (from the form or an AI draft) land in the matching offer boxes.
export async function createOffer(fields = {}, extra = {}) {
  const name = (fields.name || '').trim() || 'New offer';
  let offer_id = null;
  if (workspace.partner_id) {
    const { data, error } = await supabase.from('map_offers').insert({
      partner_id: workspace.partner_id, name, status: 'draft',
      promise_text: fields.result || null, value_text: fields.what_it_is || null,
      how_text: fields.how_it_works || null,
      ask_type: fields.price ? 'money' : null, ask_note: fields.price || null
    }).select('id');
    if (error || !data?.length) throw new Error(error?.message || 'Could not make the offer');
    offer_id = data[0].id;
  }
  const row = { workspace_id: workspace.id, name, status: 'draft', offer_id, ...extra };
  if (!offer_id) Object.assign(row, {
    what_it_is: fields.what_it_is || null, how_it_works: fields.how_it_works || null,
    result: fields.result || null, price: fields.price || null, real_cost: fields.real_cost || null
  });
  const { data, error } = await supabase.from('bb_deals').insert(row).select().single();
  if (error) throw error;
  return data;
}
